import type {Dispatch} from "redux";

import {catch5xx, catch400, postRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {userPreferencesApiLink} from "@pg-mono/services-api-routes";

import {msStoreApi} from "../../app/api/ms_store_api";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import type {IUserPreferences} from "../interfaces/IUserPreferences";
import {fetchUserPreferencesTypes} from "./fetch_user_preferences";

const POST_USER_PREFERENCES_PREFIX = "user/SAVE_PREFERENCES";

export const saveUserPreferencesTypes = createRequestActionTypes(POST_USER_PREFERENCES_PREFIX);

const requestDebounceTime = 2000;

let lastRequestActionId: ReturnType<typeof setTimeout>;

export const postUserPreferences =
    (preferences: IUserPreferences, debounce = false) =>
    async (dispatch: Dispatch) => {
        const url = userPreferencesApiLink.userPreferences.base(null);

        dispatch({type: saveUserPreferencesTypes.start});

        const sendRequest = () =>
            postRequest({}, url, {...preferences})
                .then((result: {data: {filters: Record<string, number | number[]>} | null}) => {
                    if (result) {
                        dispatch({type: saveUserPreferencesTypes.success});
                        dispatch({type: fetchUserPreferencesTypes.start});
                        dispatch({type: fetchUserPreferencesTypes.success, result: result.data});

                        dispatch(msStoreApi.util.invalidateTags(["userPreferences"]));

                        return true;
                    }

                    return false;
                })
                .catch(
                    catch400((error) => {
                        dispatch({type: saveUserPreferencesTypes.error});

                        notifyBugsnag(error, "Error 400 in postUserPreferences", error);

                        return false;
                    })
                )
                .catch(
                    catch5xx((error) => {
                        dispatch({type: saveUserPreferencesTypes.error});

                        notifyBugsnag(error, "Error 500 in postUserPreferences", error);

                        return false;
                    })
                );

        const sendRequestWithDebounce = () => {
            if (lastRequestActionId) {
                clearTimeout(lastRequestActionId);
            }

            lastRequestActionId = setTimeout(sendRequest, requestDebounceTime);
        };

        return debounce ? sendRequestWithDebounce() : sendRequest();
    };
import type {Dispatch} from "redux";

import {catch5xx, catch400, postRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {userPreferencesApiLink} from "@pg-mono/services-api-routes";

import {msStoreApi} from "../../app/api/ms_store_api";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import type {IUserPreferences} from "../interfaces/IUserPreferences";
import {fetchUserPreferencesTypes} from "./fetch_user_preferences";

const POST_USER_PREFERENCES_PREFIX = "user/SAVE_PREFERENCES";

export const saveUserPreferencesTypes = createRequestActionTypes(POST_USER_PREFERENCES_PREFIX);

const requestDebounceTime = 2000;

let lastRequestActionId: ReturnType<typeof setTimeout>;

export const postUserPreferences =
    (preferences: IUserPreferences, debounce = false) =>
    async (dispatch: Dispatch) => {
        const url = userPreferencesApiLink.userPreferences.base(null);

        dispatch({type: saveUserPreferencesTypes.start});

        const sendRequest = () =>
            postRequest({}, url, {...preferences})
                .then((result: {data: {filters: Record<string, number | number[]>} | null}) => {
                    if (result) {
                        dispatch({type: saveUserPreferencesTypes.success});
                        dispatch({type: fetchUserPreferencesTypes.start});
                        dispatch({type: fetchUserPreferencesTypes.success, result: result.data});

                        dispatch(msStoreApi.util.invalidateTags(["userPreferences"]));

                        return true;
                    }

                    return false;
                })
                .catch(
                    catch400((error) => {
                        dispatch({type: saveUserPreferencesTypes.error});

                        notifyBugsnag(error, "Error 400 in postUserPreferences", error);

                        return false;
                    })
                )
                .catch(
                    catch5xx((error) => {
                        dispatch({type: saveUserPreferencesTypes.error});

                        notifyBugsnag(error, "Error 500 in postUserPreferences", error);

                        return false;
                    })
                );

        const sendRequestWithDebounce = () => {
            if (lastRequestActionId) {
                clearTimeout(lastRequestActionId);
            }

            lastRequestActionId = setTimeout(sendRequest, requestDebounceTime);
        };

        return debounce ? sendRequestWithDebounce() : sendRequest();
    };
